import Vue from "vue";
import VueRouter from "vue-router";
import HomePage from "@/components/homepage";
import RegisterPage from "@/components/register";
import LoginPage from "@/components/login";
import PricingPage from "@/components/pricingpage";
import LibraryPage from "@/components/library";
import VideoPage from "@/components/videopage";
import PassRecover from "@/components/passrecover";
import UploadVideo from "@/components/uploadvideo";
import UserAdminPage from "@/components/user_admin";
import Stream from "@/components/streampage";
import AboutUs from "@/components/about_us";
import StreamVideoPage from "@/components/streamvideo";
import MyLibrary from "@/components/my_library";
import Renew from "@/components/renovar";
import AfterPayment from "@/components/afterPayment";
import Privacidad from "@/components/privacidad";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home Page",
    component: HomePage
  },
  {
    path: "/registrar",
    name: "Register Page",
    component: RegisterPage
  },
  {
    path: "/login",
    name: "Login Page",
    component: LoginPage
  },
  {
    path: "/recuperar_contrasena",
    name: "Recuperar",
    component: PassRecover
  },
  {
    path: "/precio",
    name: "Precio",
    component: PricingPage
  },
  {
    path: "/biblioteca",
    name: "Biblioteca",
    component: LibraryPage
  },
  {
    path: "/video/:id?",
    name: "Video",
    component: VideoPage
  },
  {
    path: "/subir_video",
    name: "SubirVideo",
    component: UploadVideo
  },
  {
    path: "/en_vivo",
    name: "EnVivo",
    component: Stream
  },
  {
    path: "/user_admin",
    name: "UserAdminPage",
    component: UserAdminPage
  },
  {
    path: "/barrepro",
    name: "BarrePro",
    component: AboutUs
  }
  ,
  {
    path: "/s_video/:id?",
    name: "Stream_Video",
    component: StreamVideoPage
  }
  ,
  {
    path: "/my_space",
    name: "MySpace",
    component: MyLibrary
  }  ,
  {
    path: "/renew",
    name: "Renovar",
    component: Renew
  }  ,
  {
    path: "/after-p",
    name: "After Payment",
    component: AfterPayment
  }  ,
  {
    path: "/privacidad",
    name: "Privacidad",
    component: Privacidad
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;

import VueYouTubeEmbed from "vue-youtube-embed";

Vue.use(VueYouTubeEmbed);

const app = new Vue({
  el: "#app",
  data: {
    videoId: "videoId"
  },
  methods: {
    ready(event) {
      this.player = event.target;
    },
    playing(event) {
      // The player is playing a video.
    },
    change() {
      // when you change the value, the player will also change.
      // If you would like to change `playerVars`, please change it before you change `videoId`.
      // If `playerVars.autoplay` is 1, `loadVideoById` will be called.
      // If `playerVars.autoplay` is 0, `cueVideoById` will be called.
      this.videoId = "another video id";
    },
    stop() {
      this.player.stopVideo();
    },
    pause() {
      this.player.pauseVideo();
    }
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js